/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Card, Form, Input, Popconfirm } from "antd";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";

const AddCards = (props) => {
  const [cardItems, setCardItems] = useState([]);
  const [itemName, setItemName] = useState([]);
  const [isShowAdd, setIsShowAdd] = useState(false);

  function handleAddCards() {
    const newItem = {
      id: uuidv4(),
      itemName: itemName.key // Get the previous value from the state
    };
    const newList = cardItems.concat(newItem);
    setCardItems(newList);
    setIsShowAdd(true);
    setItemName([]); // Reset the itemName state after adding a card area
  }
  const [form] = Form.useForm();

  function handleRemoveAccount(id) {
    const newList = cardItems.filter((item) => item.id !== id);
    setCardItems(newList);
  }

  const onFinish = (values) => {
    console.log('Form submitted!', values);
    props.onAdd(itemName);
    setIsShowAdd(false);
    setCardItems([]);
  };

  function handleBlur() {
    form.submit();
  }

  const handleInput = (e) => {
    setItemName({
      key: e.target.value,
      itemCardTitle: e.target.value,
      items: [],
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const validateInput = (_, value) => {
    if (!value) {
      return Promise.reject("Please enter a value");
    }
    return Promise.resolve();
  };

  return (
    <div>
      {isShowAdd &&
        cardItems.map((item, index) => (
          <div key={item.id}>
            <Card
              title={
                <Form
                  name="basic"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                  style={{
                    maxWidth: 600,
                    margin: "10px",
                  }}
                  form={form} 
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    name={`cardItemTitle${index}`}
                    rules={[{ validator: validateInput }]}
                  >
                    <Input
                      autoFocus
                      onBlur={handleBlur}
                      onChange={handleInput}
                      placeholder="Enter an area name..."
                    />
                  </Form.Item>
                  <Button type="submit" style={{ display: 'none' }} />
                </Form>
              }
              extra={
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => handleRemoveAccount(item.id)}
                >
                  <a style={{ color: "red" }}>Delete Area</a>
                </Popconfirm>
              }
            >
              <Button type="text" style={{ width: "100%" }} disabled>
                <i
                  className="fa-solid fa-plus"
                  style={{ marginRight: "5px" }}
                ></i>{" "}
                Add Item
              </Button>
            </Card>
            <br />
          </div>
        ))}
      <Button
        type="primary"
        style={{ width: "100%" }}
        onClick={handleAddCards}
      >
        <i className="fa-solid fa-plus" style={{ marginRight: "5px" }}></i> Add
        Area
      </Button>
    </div>
  );
};

export default AddCards;
